import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const H1Styles = css `
  ${fonts.inter.extraBold};

  font-size: ${fluid(24, 56)};
  line-height: ${fluid(40, 80)};
  margin-bottom: 16px;
`;
const H2Styles = css `
  ${fonts.inter.extraBold};

  font-size: ${fluid(20, 48)};
  line-height: ${fluid(35, 70)};
  margin-bottom: 16px;
`;
const H3Styles = css `
  ${fonts.inter.extraBold};

  font-size: ${fluid(18, 40)};
  line-height: ${fluid(32, 60)};
  margin-bottom: 16px;
`;
const H4Styles = css `
  ${fonts.inter.extraBold};

  font-size: ${fluid(16, 32)};
  line-height: ${fluid(30, 50)};
  margin-bottom: 16px;
`;
const H5Styles = css `
  ${fonts.inter.extraBold};

  font-size: ${fluid(14, 24)};
  line-height: ${fluid(24, 38)};
  margin-bottom: 16px;
`;
const Heading = styled(m.h1) `
  ${({ visual }) => {
    switch (visual) {
        case 'h1':
            return H1Styles;
        case 'h2':
            return H2Styles;
        case 'h3':
            return H3Styles;
        case 'h4':
            return H4Styles;
        case 'h5':
            return H5Styles;
        default:
            break;
    }
}}

  text-wrap: pretty;

  &:has(${() => Line}) {
    display: flex;
    gap: 8px;
  }

  @media ${until(Device.Tablet)} {
    flex-direction: column;
    color: ${brand.primary.grey.dark};
  }

  @media ${from(Device.Tablet)} {
    align-items: flex-end;
  }

  span {
    flex-shrink: 0;
  }
`;
const Line = styled(m.div).attrs((props) => ({
    initial: 'hidden',
    animate: props['showLine'] ? 'visible' : 'hidden',
    variants: {
        hidden: {
            width: '0px',
        },
        visible: {
            width: '100%',
        },
    },
    transition: {
        duration: 1,
        ease: 'easeInOut',
    },
})) `
  background-color: ${brand.primary.blue.base};
  height: 4px;
  margin-bottom: 9px;
`;
export default {
    H1Styles,
    H2Styles,
    H3Styles,
    H4Styles,
    H5Styles,
    Heading,
    Line,
};
